import styled from '@emotion/styled';
import { mediaQuery } from 'src/common';

export * from './typography';
export * from './buttons';
export * from './layout';
export * from './icons';
export * from './grid';
export * from './other';
export * from './cards';
export * from './forms';
export * from './modals';
export * from './inputs';
export * from './captcha';
export { default as BottomDrawer } from './modals/bottomDrawer.modal';


export const MobileContainer = styled.div({
  display: 'block', // Show by default on mobile
  [mediaQuery('laptop')]: {
    display: 'none', // Hide on laptop and above
  },
});

export const DesktopContainer = styled.div({
  display: 'none', // Hide by default on mobile
  [mediaQuery('laptop')]: {
    display: 'block', // Show on laptop and above
  },
});